// extracted by mini-css-extract-plugin
export default {"coverage":"CoverageTab_coverage__d3Oqo","center":"CoverageTab_center__biwSg","summaryRow":"CoverageTab_summaryRow__4ax0y","summary":"CoverageTab_summary__udLwO"};